export type ColorScheme = 'light' | 'dark'

export function getPreferredColorScheme(): ColorScheme {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export function onColorSchemeChange(handler: (scheme: ColorScheme) => void): () => void {
  const mq = window.matchMedia('(prefers-color-scheme: dark)')
  const listener = (event: MediaQueryListEvent) => {
    handler(event.matches ? 'dark' : 'light')
  }
  mq.addEventListener('change', listener)
  return () => mq.removeEventListener('change', listener)
}